<template>
    <div style="padding: 16px 16px;    height: calc(100vh - 100px);
    background-color: #080718ff;
    overflow-y: scroll;
    padding-bottom: 30px; background-color: #080718ff; color: #fff" >

    </div>
</template>


<script lang="ts" setup>
import { defineComponent, onMounted, onUnmounted, reactive, ref, watch } from "vue";
import { useRouter } from "vue-router";
// import request from "../../common/request";
import { v4 as uuidv4 } from "uuid";





</script>


<style lang="less" scoped>
.box {
    border: 1px solid #171325ff;
    background: #171325ff;
}
</style>